import Vue from 'vue'
import firebase from '@/firebase/firebase'
import _misc from '@/assets/utils/misc.js'

const db = firebase.firestore()

const defaultFilter = {
    date : {
        from : new Date(),
        to : new Date()
    },
    opionOnly : false,
    selectedTags : [],
    stars : 0
}

function fixDateFrom (date) {
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    return date
}

function fixDateTo (date) {
    date.setHours(23)
    date.setMinutes(59)
    date.setSeconds(59)
    return date
}

export default {
    namespaced: true,

    state : {
        ratings : [],
        _filter : { ...defaultFilter }
    },

    getters : {
        filteredRatings (state) {
            let ratings = state.ratings.filter(a => state._filter.stars > 0 ? a.rating == state._filter.stars : state.ratings)
            if(state._filter.opionOnly)
                ratings = ratings.filter(a => a.textOpinion.length > 0)
            if(state._filter.selectedTags.length > 0) 
                ratings = ratings.filter(rating => (rating.comments.filter(comment => state._filter.selectedTags.findIndex(t => t.value == comment) >= 0) ).length )

            return ratings
        },

        averageRating (state) {
            const totalSumRating = state.ratings.reduce((total, num) => total + num.rating, 0)
            const maxRating = state.ratings.length * 5
            const average = (totalSumRating * 5) / maxRating
            return _misc.truncateDecimals(average, 10)
        },

        statisticsRatings (state) {
            let totalRatings = []
            // OBJ: { date : 'YYYY-MM-DD', ratings : [ { star : 5, total: 10, desc : '5 estrelas' } ] }
            
            state.ratings.forEach(rating => {
                const ratingDate = Vue.moment(new firebase.firestore.Timestamp(rating.ratedAt.seconds, rating.ratedAt.nanoseconds).toDate()).format('YYYY-MM-DD')
                const foundTotalRatings = totalRatings.find(a => a.date == ratingDate) 
                if(foundTotalRatings) {
                    const foundRating = foundTotalRatings.ratings.find(a => a.star == rating.rating)
                    if(foundRating)
                        foundRating.total += 1
                    else 
                        foundTotalRatings.ratings.push({ star : rating.rating, total : 1 })
                }
                else 
                    totalRatings.push({ date : ratingDate, ratings : [ { star : rating.rating, total : 1 }] })

            })

            for (let i = 1; i <= 5; i++) {
                totalRatings.forEach(rating => {
                    const foundStar = rating.ratings.findIndex(a => a.star == i)
                    if(foundStar < 0) 
                        rating.ratings.push({ star : i, total : 0 })

                    rating.ratings = rating.ratings.sort((a,b) => b.star - a.star)
                })
            }

            totalRatings = totalRatings.sort((a,b) => Vue.moment(a.date) - Vue.moment(b.date))
            return totalRatings
        }
    },

    actions : {
        async fetchRatings ({state, rootGetters, commit}, { dateRange }) {
            const companyId = rootGetters.getCompanyID
            const ratingSnap = await db.collection(`/company/${companyId}/ratings`)
                .where('ratedAt', '>=', fixDateFrom(state._filter.date.from))
                .where('ratedAt', '<=', fixDateTo(state._filter.date.to))
                .get()
            if(!ratingSnap.size)
                throw new Error('Não há registros para a data informada')
            
            let ratings = ratingSnap.docs.map(doc => doc.data())
                .sort((a, b) => b.rating - a.rating)
            commit('setRatings', ratings)
        }
    },

    mutations : {
        setDateFrom (state, fromDate ) {
            state._filter.date.from = fromDate
        },

        setDateTo (state, toDate ) {
            state._filter.date.to = toDate
        },

        setOpionOnlyFilter (state, bool) {
            state._filter.opionOnly = bool
        },

        setSelectedTags (state, tags) {
            Vue.set(state._filter, 'selectedTags', tags)
        },

        setStars (state, qty) {
            state._filter.stars = qty
        },
        
        setRatings (state, ratings) {
            state.ratings = ratings
        },
        
        clearFields (state) {
            state._filter = { date : { to : new Date(), from : new Date() }, stars : 0, opionOnly : false, selectedTags : [] }
            state.ratings = []
        },

        resetStars (state) {
            state._filter.stars = 0
        },
    }
}